import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IId } from 'interfaces/common/common';

import { INotification } from '@interfaces/notifications/notifications';

interface IInitialState {
	notificationList: Array<INotification>;
	unreadNotificationsCount: number;
	notificationsCount: number;
	isLoadingNotifications: boolean;
}

const initialState: IInitialState = {
	notificationList: [],
	unreadNotificationsCount: 0,
	notificationsCount: 0,
	isLoadingNotifications: false,
};

const notifications = createSlice({
	name: 'notifications',
	initialState,
	reducers: {
		setNotifications: (state, action: PayloadAction<{
			notifications: Array<INotification>;
		}>) => {
			state.notificationList = [...state.notificationList, ...action.payload.notifications];

			state.isLoadingNotifications = false;
		},
		setIsLoadingNotifications: (state, action: PayloadAction<{
			isLoading: boolean;
		}>) => {
			state.isLoadingNotifications = action.payload.isLoading;
		},
		removeNotificationFromList: (state, action: PayloadAction<{
			id: string;
		}>) => {
			state.notificationList = state.notificationList.filter((notification: INotification) =>
				notification.id !== action.payload.id);

			state.notificationsCount = state.notificationsCount - 1;
		},
		readNotificationsFromList: (state, action: PayloadAction<IId>) => {
			state.notificationList = state.notificationList
				.filter(notification => notification.organizationId === action.payload.id)
				.map((notification: INotification) => ({
					...notification,
					isRead: true,
				}));

			state.unreadNotificationsCount = initialState.unreadNotificationsCount;
		},
		removeNotificationsFromList: (state) => {
			state.notificationList = initialState.notificationList;

			state.unreadNotificationsCount = initialState.unreadNotificationsCount;

			state.notificationsCount = initialState.notificationsCount;
		},
		setNewNotification: (state, action: PayloadAction<{
			notification: INotification;
		}>) => {
			state.notificationList = [action.payload.notification, ...state.notificationList];

			state.unreadNotificationsCount = state.unreadNotificationsCount + 1;

			state.notificationsCount = state.notificationsCount + 1;
		},
		setUnreadNotificationsCount: (state, action: PayloadAction<{
			unreadNotificationsCount: number;
		}>) => {
			state.unreadNotificationsCount = action.payload.unreadNotificationsCount;
		},
		setNotificationsCount: (state, action: PayloadAction<{
			notificationsCount: number;
		}>) => {
			state.notificationsCount = action.payload.notificationsCount;
		},
	},
});

export const {
	setNotifications,
	setNewNotification,
	setUnreadNotificationsCount,
	removeNotificationFromList,
	readNotificationsFromList,
	removeNotificationsFromList,
	setNotificationsCount,
	setIsLoadingNotifications,
} = notifications.actions;

export default notifications.reducer;
